import type { FourValueTupleConvertable } from '@elfsight/widget-utils';

const DEFAULT_ICON_PADDING = 12;
const VERTICAL_PADDING_RATIO = 0.66;
const ICON_PADDING_RATIO = 0.82;

export function calculatePadding(
  fontSize: number,
  withLabel: boolean,
  iconPosition: 'left' | 'right' | false,
  underlineMode: boolean
): FourValueTupleConvertable<number> {
  const horizontalPadding = underlineMode ? 0 : fontSize;

  if (withLabel) {
    return [
      fontSize,
      iconPosition === 'right' ? DEFAULT_ICON_PADDING : horizontalPadding,
      fontSize,
      iconPosition === 'left' ? DEFAULT_ICON_PADDING : horizontalPadding
    ];
  }

  return [
    Math.round(fontSize * VERTICAL_PADDING_RATIO),
    iconPosition === 'right'
      ? Math.round(ICON_PADDING_RATIO * fontSize)
      : horizontalPadding,
    Math.round(fontSize * VERTICAL_PADDING_RATIO),
    iconPosition === 'left'
      ? Math.round(ICON_PADDING_RATIO * fontSize)
      : horizontalPadding
  ];
}
